export const es = {
  // Header
  nav: {
    home: "Inicio",
    skills: "Habilidades",
    experience: "Experiencia",
    projects: "Proyectos",
    contact: "Contacto & CV"
  },

  // Home
  home: {
    role: "Responsable de Explotación de Mantenimiento",
    bio1: "¡Hola y bienvenido a mi portafolio! Actualmente soy responsable de explotación de mantenimiento multitécnico en un edificio de pública concurrencia (ERP) en Montpellier, donde dirijo un equipo de 3 técnicos (CVC, electricidad, polivalencia) en un sitio terciario de 70 000 m² que recibe a más de 500 000 visitantes al año.",
    bio2: "Con una sólida experiencia en campo y pasión por la automatización, combino la gestión operativa con misiones transversales (apoyo a operaciones, consolidación de datos SAP). Innovo diariamente para optimizar procesos a través de la Industria 4.0 (PowerBI, Power Automate), economía circular (impresión 3D) y mejora continua."
  },

  // Language Skills
  languageSkills: {
    french: "Francés",
    english: "Inglés",
    spanish: "Español",
    nativeLevel: "Nativo",
    advancedLevel: "C1",
    intermediateLevel: "B1",
    nativeProficiency: "Lengua Materna",
    advancedProficiency: "Avanzado",
    intermediateProficiency: "Intermedio",
    reading: "Lectura",
    writing: "Escritura",
    speaking: "Hablar",
    listening: "Escucha",
    basicWriting: "Escritura básica",
    basicSpeaking: "Hablar básico",
    proficiency: "Competencia"
  },

  // Tech Skills (just category titles, as there are too many skills to translate)
  techSkills: {
    maintenanceSkills: "Habilidades de mantenimiento",
    gmaoSystems: "Sistemas GMAO y ERP",
    performanceMonitoring: "Seguimiento de rendimiento",
    continuousImprovement: "Mejora continua",
    projectManagement: "Gestión de proyectos",
    designEngineering: "Diseño e Ingeniería",
    officeProductivity: "Ofimática y Productividad",
    databasesData: "Bases de datos y Datos",
    osSystems: "Sistemas operativos e Infraestructura",
    programmingLanguages: "Lenguajes de programación",
    devOpsTools: "DevOps y Herramientas",
    webTechnologies: "Tecnologías Web"
  },

  projectTechnologies: {
    m5stick: "M5 Stick",
    blynk: "Blynk",
    debian: "Debian",
    raspberrypi: "Raspberry Pi",
    apiYaskawa: "PLC Yaskawa",
    vfd: "VFD",
    energyEfficiency: "Eficiencia Energética",
    roiAnalysis: "Análisis ROI",
    compressor: "Compresor",
    economy: "Economía",
    design3d: "Diseño 3D",
    printing3d: "Impresión 3D",
    cad: "CAD",
    formlabs: "Formlabs",
    sustainability: "Sostenibilidad"
  },

  footer: {
    contact: "Contáctame",
    rights: "Todos los derechos reservados."
  },

  techSkillsList: {
    maintenance: {
      system: { name: "Mantenimiento de sistemas", details: "Procedimientos de mantenimiento preventivo y correctivo para equipos industriales e infraestructura de TI." },
      reliability: { name: "Fiabilidad", details: "Análisis MTBF/MTTR, cálculo de índices de fiabilidad, revisión de fallos e implementación de estrategias de mejora." },
      predictive: { name: "Mantenimiento predictivo", details: "Implementación de sistemas de análisis predictivo, técnicas RCM y monitoreo de vibraciones." },
      tpm: { name: "TPM", details: "Despliegue del Mantenimiento Productivo Total, formación de operadores en automantenimiento, eliminación de las seis grandes pérdidas." },
      troubleshooting: { name: "Resolución de problemas", details: "Diagnóstico sistemático de problemas, análisis de causa raíz y resolución de problemas mecánicos y de software." },
      writing: { name: "Redacción técnica", details: "Redacción de procedimientos, modos operativos, gamas de mantenimiento y materiales de formación." }
    },
    gmao: {
      sap: { name: "SAP", details: "Planificación, gamas de mantenimiento, imputaciones y gestión de órdenes de trabajo con SAP PM." },
      dimomaint: { name: "DIMOMAINT", details: "Uso de la GMAO DIMOMAINT." },
      cegid: { name: "CEGID PMI", details: "Uso de CEGID para gestión de stock, movimientos y metrología." },
      aqmanager: { name: "AQMANAGER", details: "Instalación, configuración y uso de la herramienta AQMANAGER para GMAO." }
    },
    performance: {
      kpi: { name: "KPI", details: "Definición y seguimiento de indicadores clave de rendimiento adaptados a las actividades de mantenimiento y producción." },
      dashboards: { name: "Tableros de control", details: "Creación de tableros para seguimiento de máquinas, disponibilidad, TRS/OEE y costes de mantenimiento." }
    },
    continuousImprovement: {
      lean: { name: "Lean Management", details: "Aplicación de principios Lean para reducir desperdicios, optimizar flujos y crear valor." },
      '5s': { name: "5S", details: "Implementación de 5S para la organización y estandarización de puestos de trabajo." },
      kaizen: { name: "Kaizen", details: "Animación de eventos Kaizen, implementación de mejora continua y despliegue de cultura de cambio progresivo." },
      pareto: { name: "Pareto", details: "Análisis de Pareto (80/20), priorización de problemas críticos, enfoque en acciones de alto impacto." }
    },
    projectManagement: {
      jira: { name: "Jira", details: "Seguimiento de proyectos, gestión de incidencias y automatización de flujos de trabajo con Jira." },
      agile: { name: "AGILE", details: "Implementación de metodologías Agile incluyendo Scrum y Kanban para la entrega de proyectos." },
      sprint: { name: "SPRINT", details: "Planificación y animación de ceremonias sprint (planificación, revisión, retrospectiva)." }
    },
    design: {
      fusion: { name: "Fusion 360", details: "Modelado 3D, diseño paramétrico y simulación para componentes mecánicos y ensamblajes." },
      arduino: { name: "Arduino", details: "Prototipado de dispositivos IoT y automatización utilizando microcontroladores Arduino y sensores." },
      fritzing: { name: "Fritzing", details: "Diseño de circuitos electrónicos y layout de PCB para sistemas embebidos." }
    },
    office: {
      o365: { name: "Office 365", details: "Uso avanzado de la suite Office 365, incluyendo administración de SharePoint, Teams y Exchange." },
      powerAutomate: { name: "Power Automate", details: "Automatización de flujos con Power Automate, conectores y APIs personalizadas." },
      powerApps: { name: "PowerApps", details: "Desarrollo de aplicaciones de negocio con PowerApps usando SQL y SharePoint." },
      powerBi: { name: "Power BI", details: "Creación de tableros interactivos e informes con modelos de datos complejos y cálculos DAX." }
    },
    data: {
      sql: { name: "SQL", details: "Diseño de BDD, consultas complejas, procedimientos almacenados y migraciones de datos." },
      dax: { name: "DAX", details: "Creación de medidas y columnas calculadas con DAX para modelos Power BI." },
      powerQuery: { name: "Power Query (M)", details: "ETL utilizando lenguaje M para transformación e integración de datos." }
    },
    os: {
      debian: { name: "Debian", details: "Administración de servidores, gestión de paquetes y optimización del sistema en Debian." },
      bash: { name: "Bash/Shell", details: "Automatización mediante scripts para tareas del sistema y operaciones programadas." }
    },
    programming: {
      cpp: { name: "C++", details: "Programación de sistemas embebidos (ESP8266, Raspberry, M5Stack)." },
      csharp: { name: "C#", details: "Aplicaciones Windows .NET e integración con bases de datos SQL Server." },
      vba: { name: "VBA", details: "Automatización Excel, funciones personalizadas e interfaces para procesos de negocio." },
      python: { name: "Python", details: "Análisis de datos, scripts de automatización e integraciones API (Pandas, NumPy)." }
    },
    devops: {
      git: { name: "Git", details: "Control de versiones, estrategias de ramas y desarrollo colaborativo con Git y GitHub." },
      llm: { name: "LLM", details: "Uso y ajuste de LLM (Claude, ChatGPT) para productividad laboral." }
    },
    web: {
      node: { name: "Node.js", details: "Desarrollo API backend, middleware y aplicaciones web." }
    }
  },

  // Experience
  experience: {
    title: "Experiencia Profesional",
    present: "Presente",
    years: "año",
    yearsPlural: "años",
    months: "meses",
    workType: "trabajo",
    educationType: "educación",
    certificationType: "certificación",
    skillsType: "habilidades",
    vinciGlobalPeriod: "Abril 2024 - Presente",
    vinciGlobalLabel: "Período global VINCI",
    // Experience entries
    experiences: {
      vinci: {
        title: "Jefe de Equipo de Mantenimiento - CFO CFA Región Montpellier",
        company: "VINCI Facilities - Montpellier📍",
        period: "Abril 2024 - Diciembre 2025",
        description: "Gestión de un equipo de 7 personas responsable del mantenimiento de corriente fuerte y corriente débil (estaciones de AT, generadores, intrusión, detección de incendios).\n\nDirección del mantenimiento preventivo y correctivo con gestión de planificación, guardias y prioridades operativas.\n\nGestión y seguimiento de contratos con clientes, incluida la satisfacción y los compromisos contractuales.\n\nCreación de presupuestos, negociación y desafío a los proveedores para optimizar costos y calidad de servicios.\n\nImplementación de mejoras continuas mediante la automatización de informes de clientes, creación y envío de presupuestos, y gestión de equipos gracias a mis habilidades en Excel, PowerApps y Power Automate.\n\nEstas optimizaciones han permitido un ahorro de 1h30 por día, mejorando la productividad y la capacidad de respuesta al cliente.",
        skills: ["Gestión de equipos", "Mantenimiento preventivo", "Gestión de contratos", "Automatización de procesos", "SAP", "Excel avanzado", "PowerApps", "Power Automate"]
      },
      vinciErp: {
        title: "Responsable de Explotación de Mantenimiento - Edificio de Pública Concurrencia, Montpellier",
        company: "VINCI Facilities - Montpellier📍",
        period: "Enero 2026 - Presente",
        description: "Responsable de un equipo de 3 técnicos multiespecialistas (CVC, electricidad, todoterreno) en un edificio de pública concurrencia (ERP) en Montpellier, un sitio terciario de casi 70 000 m² que recibe a más de 500 000 visitantes al año.\n\nDirección de operaciones y mantenimiento multitécnico en un entorno exigente: restricciones reglamentarias, guardias y continuidad del servicio en un sitio de alto tráfico.\n\nDesarrollo de soluciones internas a medida para mejorar la producción y la eficiencia operativa.\n\n1er puesto individual (entre más de 100 participantes) en el CTF de Vinci Energies (Ciberseguridad, OSINT, explotación de vulnerabilidades).",
        skills: ["Gestión de equipos", "CVC", "Electricidad", "ERP", "Ciberseguridad", "Guardias", "Multitécnica", "Power Platform"]
      },
      atole: {
        title: "Técnico de Mantenimiento",
        company: "ATOLE - Castries📍",
        period: "Septiembre 2019 - Abril 2024",
        description: "Mantenimiento de equipos necesarios para la fabricación de equipos eléctricos (cajas, conductos técnicos).\n\nMantenimiento preventivo y correctivo en punzonadoras, corte láser, soldadoras semiautomáticas, plegadoras (gran parque de máquinas AMADA, TRUMPF).\n\nMantenimiento preventivo y correctivo en equipos de equipos de línea (atornilladores neumáticos, grapadoras, remachadoras, hornos de gas, taller de pintura).\n\nDesarrollo de Industria 4.0 con sensores, Arduino, PowerBI, SQL, Debian y diseño de PCB.\n\nRedacción de más de 100 documentos (procedimientos operativos, gama, formación).\n\nAdjunto informal del responsable de mantenimiento (gestión, formación de nuevas incorporaciones, proyectos).",
        skills: ["Mantenimiento industrial", "Equipos AMADA & TRUMPF", "Arduino", "SQL", "Diseño de PCB", "PowerBI", "Debian", "Documentación técnica"]
      },
      grtgaz: {
        title: "Técnico de Mantenimiento",
        company: "GRTgaz - Nozay📍",
        period: "Septiembre 2016 - Julio 2019",
        description: "Mantenimiento en servicio de 5 turbocompresores utilizados para comprimir gas, así como del proceso de gas que los rodea.\n\nGestión de residuos (retiradas ADR).\n\nGestión de trabajos en cooperación con empresas externas (a menudo extranjeras).",
        skills: ["Mantenimiento de turbocompresores", "Sistemas de gas", "Gestión de residuos", "Coordinación de contratistas", "Equipos industriales"]
      },
      bts: {
        title: "BTS en Mantenimiento de Sistemas Energéticos y Fluídicos",
        company: "Formación - Aix En Provence📍",
        period: "2015 - 2016",
        description: "BTS en Mantenimiento de Sistemas Energéticos y Fluídicos, profundización de las calificaciones anteriores con una especialización en sistemas industriales.\n\nActualmente cursando una Licencia Profesional en Mantenimiento a través de VAE.",
        skills: ["Sistemas energéticos", "Mecánica de fluidos", "Mantenimiento industrial", "Documentación técnica"]
      },
      bac: {
        title: "Bachillerato Profesional M.E.I",
        company: "Formación - Istres📍",
        period: "2013 - 2015",
        description: "Bachillerato profesional en Mantenimiento de Equipos Industriales (M.E.I), formación completa sobre técnicas de mantenimiento y sistemas industriales.",
        skills: ["Mantenimiento de equipos", "Resolución de problemas", "Dibujo técnico", "Mantenimiento preventivo"]
      },
      certifications: {
        title: "Certificaciones Profesionales",
        company: "Varios organismos de certificación",
        period: "2016 - Presente",
        description: "Múltiples certificaciones profesionales con equivalentes norteamericanos: Primeros Auxilios y RCP/DEA (equivalente SST — Standard First Aid de la Cruz Roja Canadiense), Capacitación en Seguridad Eléctrica / Arc Flash (equivalente GIES1 — NFPA 70E), Certificación de Operador de Montacargas (equivalente CACES 3 — OSHA / CSA B335), Instalación de Conexiones Swagelok, Autorización de Alta/Baja Tensión (equivalente AT/BT), y Capacitación en Protección contra Caídas / Trabajo en Altura (equivalente uso de arneses).",
        skills: ["Certificaciones de seguridad", "Operación de equipos", "Seguridad eléctrica", "Primeros auxilios", "CACES 3"]
      },
      technical: {
        title: "Habilidades Técnicas",
        company: "Aplicaciones e Idiomas",
        period: "En continuo",
        description: "Dominio de software GMAO y ERP: SAP, DIMOMAINT, CEGID PMI, AQMANAGER.\n\nOfimática y productividad: Office 365, PowerPlatform.\n\nDiseño y prototipado: Fusion 360, Arduino, Fritzing.\n\nLenguajes y sistemas: Debian, Bash, Shell, C++, C#, VBA, PYTHON, SQL, DAX, POWER QUERY (M).",
        skills: ["SAP", "Office 365", "PowerPlatform", "Fusion 360", "Arduino", "Python", "SQL", "VBA"]
      }
    }
  },

  // Appointment Form
  appointment: {
    title: "Responsable de Mantenimiento",
    intro: "Como Responsable de Mantenimiento experimentado, he desarrollado una sólida experiencia en gestión de equipos, optimización de equipos y mejora continua de procesos industriales. Con varios años de experiencia, pongo mis habilidades al servicio del desarrollo y la fiabilidad de las infraestructuras, combinando estrategia de mantenimiento y rendimiento operativo.",
    scheduleInterview: "Programar una entrevista",
    scheduleDesc: "Reserve una cita por video",
    contactLinkedIn: "Contácteme en LinkedIn",
    linkedInDesc: "Consulte mi perfil de LinkedIn para conocer más sobre mi trayectoria profesional",
    sendEmail: "Enviarme un correo",
    emailDesc: "Contácteme por correo para un primer intercambio",
    downloadCV: "Descargar mi CV",
    cvDesc: "Obtenga una copia de mi CV para descubrir mis habilidades",
    availability: "Gracias por su visita",
    availabilityStatus: ""
  },

  // Projects
  projects: {
    title: "Mis Proyectos",
    dmhCounter: {
      title: "Contador DMH",
      description: "Monitoreo del producto durante la producción más umbral de DMH con alertas para respetar los tiempos de producción."
    },
    compressorEfficiency: {
      title: "Eficiencia del Compresor",
      description: "Análisis de las ganancias de eficiencia de la conversión de un compresor de aire a VFD, que muestra un ROI de 2 años en una inversión de 20k €."
    },
    threeDPrinting: {
      title: "Ahorro con Impresión 3D",
      description: "Varios miles de euros de ahorro en varios proyectos."
    }
  }
};
